import React, { useState } from 'react';

import { EmailCampaignSignupSingleBlockData } from 'api/cms';
import { FormSubmitFunction } from 'components/Form';
import { postJson } from 'utils/http';

import { EmailCampaignSignup } from './EmailCampaignSignup';

type Props = {
  blockId: string;
  data: EmailCampaignSignupSingleBlockData;
  isSidebar?: boolean;
};

export function EmailCampaignSignupSingleBlock({
  blockId,
  data: { headline, buttonText, bgImage },
  isSidebar,
}: Props) {
  const [mode, setMode] = useState('initial');

  const onSubmit: FormSubmitFunction<EmailCampaignSignupSingleBlockData> = ({
    values,
    handleError,
  }) => {
    const postBaseUrl = isSidebar
      ? '/data/website/sidebar-email-signup-single/'
      : '/data/website/page-email-signup-single/';
    setMode('submitting');
    postJson(postBaseUrl + blockId, values)
      .then(() => {
        setMode('submitted');
      })
      .catch((e) => {
        handleError(e);
        setMode('initial');
      });
  };

  return (
    <EmailCampaignSignup
      disabled={mode === 'submitting'}
      onSubmit={onSubmit}
      headline={headline}
      buttonText={buttonText}
      isSidebar={isSidebar}
      isSubmitted={mode === 'submitted'}
      bgImage={bgImage}
      qaId="cms-email-campaign-signup-single"
    />
  );
}
